
<template>
    <div>
        <v-card class="main-card" v-if="!$AuthSvc.isLogin()">
            <v-card-title style="padding-bottom:0">
                <span class="page-title">Registration</span>
            </v-card-title>
            <span>Must login to register</span>
        </v-card>

        <v-card class="main-card" v-if="$AuthSvc.isLogin() && scoreCard !== null && tournament.status === 'REGISTER'">
            <v-card-text v-if="tournament!==null">
                <span class="label18">Congratulations!</span><br/><br/>
                <span class="label14">You have registered for {{tournament.course.name}}.</span>
                <span v-if="scoreCard.owe > 0">
                    <br>
                    You still owe the amount of ${{scoreCard.owe}}.<br>
                    <span v-if="scoreCard.paymentType!=='Complimentary'">
                        You preferred to pay by {{scoreCard.paymentType}}.
                    </span>
                    <span v-if="scoreCard.paymentType==='Complimentary'">
                        Your payment selection is Complimentary and requires an approval.
                    </span>
                    <br>
                </span>

                <span v-if="!isBanquet() && scoreCard.paymentType==='Complimentary'">
                    <br/>
                    PLEASE BE AWARE: <br>
                    If you choose "Complimentary", the DFWVGA President/Treasurer will review your
                    enrollment and MUST approve your complement fee before the deadlline.<br/>
                    Please contact Vincent Tran at (682) 703-6172 if you have any questions.
                    <br>
                </span>
                <span v-if="scoreCard.paymentType==='Zelle' && tournament.formatType==='TOURNAMENT' && scoreCard.owe > 0">
                    <br/>
                    Please ZELLE to <b>pay@dfwvga.com</b> before the tournament deadline.
                    <br/>
                </span>

                <v-card-actions class="actions-card" v-if="scoreCard.paymentType==='PayPal' && scoreCard.owe > 0">
                    <v-btn style="background-color:darkgreen;color:white;" @click="invoice()">Pay Now</v-btn>
                </v-card-actions>
                <br>

                <span v-if="scoreCard.owe > 0">
                    All dues MUST BE PAID before the deadline {{printDateTime(tournament.registrationDeadline)}}
                    in order to participate in the tournament, otherwise your registration will be CANCELLED and awarded to
                    standby's.
                    <br> <br>
                </span>
                <span class="label14" v-if="scoreCard.owe === 0 && !isBanquet()">
                    <br>
                    See you at the golf course!
                </span>
                <span class="label14" v-if="scoreCard.owe === 0 && isBanquet()">
                    <br>
                    See you at the party!
                </span>
            </v-card-text>

        </v-card>

        <v-card class="no-login" v-if="$AuthSvc.isLogin() && tournament === null">
            <v-card-title style="padding-bottom:0">
                <span class="page-title">Registration</span>
            </v-card-title>
                    No tournaments to register at this time.
        </v-card>

        <v-card class="main-card" v-if="$AuthSvc.isLogin() && scoreCard === null && tournament !== null">
            <v-card style="padding: 20px" class="mx-auto mt-5">
                <v-card-title>
                    <span class="page-title">Registration</span>
                </v-card-title>
                <br>

                <v-card class="registration-card">
                    <v-card-text v-if="tournament!==null">
                        <span class="label14">Course: </span> {{tournament.course.name}} <br/>
                        <span class="label14">Schedule Date: </span> {{printDateTime(tournament.scheduleDate)}} <br/><br/>

                        <span class="label14">Name: </span> {{$AuthSvc.getFullName()}} <br/>
                        <span class="label14">Email: </span> {{$AuthSvc.getUserInfo().email}} <br/>
                        <span class="label14">Flight: </span> {{getFlight($AuthSvc.getUserInfo().flight)}} <br/>
                        <span class="label14">Member Status: </span> {{$AuthSvc.getUserInfo().status}}<br/>
                        <div  v-if="$AuthSvc.isJunior()" style="width: 100%">
                            <span class="label14">Status: </span>Approved JUNIOR<br/>
                        </div>
                        <div  v-if="$AuthSvc.isSenior()" style="width: 100%">
                            <span class="label14">Status: </span>Approved SENIOR<br/>
                        </div>
                        <br/>
                        <div style="width: 100%" v-if="tournament.formatType==='TOURNAMENT' && isEarly(tournament.earlyRegisterDeadline)">
                            <span v-if="!isBanquet()" class="label16">Member Early Fee: </span>
                            <span v-if="isBanquet()" class="label16">Member Free + 1 guest: </span>
                            <span v-if="!isBanquet()">${{Number(tournament.memberFee)}}</span>
                            <span v-if="isBanquet()">FREE</span>
                            <span v-if="!isBanquet()" class="noteText">
                                 (MUST BE PAID BY {{printDate(tournament.earlyRegisterDeadline)}})
                            </span>
                        </div>
                        <div style="width: 100%" v-if="!isBanquet() && tournament.formatType==='TOURNAMENT' && !isEarly(tournament.earlyRegisterDeadline)">
                            <span class="label16">Member Fee: </span>
                            <span>${{memberFee}}</span>
                        </div>

                        <div>
                            <span class="label16">Guest Fee: </span>
                            <span>${{tournament.guestFee}}</span> &nbsp; &nbsp;

                            <span v-if="isBanquet()">(Per Guest)</span>
                        </div>
                        <div v-if="!isBanquet()">
                            <span class="label16">Junior Fee: </span>
                            <span>${{tournament.juniorFee}}</span>
                        </div>
                        <div v-if="!isBanquet()">
                            <span v-if="$AuthSvc.isJunior()">
                                <br/>
                                For JUNIOR registration, DFWVGA has granted a discount flat fee of ${{JUNIOR_FEE}} on your Tournament Fee
                                and membership fee is free if your parent is a member.
                                You are required to prove that your are less than 18 yrs of age. The DFWVGA President will
                                approve your registration once verification has been confirmed. You can either ZELLE your balance
                                to dfwvga.info@dfwvga.com, or settle your fee at the golf course.
                                <br/>
                            </span>

                            <span v-if="$AuthSvc.isSenior()">
                                <br/>
                                For SENIOR registration, DFWVGA has granted a discount for Membership Fee $60.
                                You are required to prove that your are greater or equal 65 yrs of age. The DFWVGA President will
                                approve your registration once verification has been confirmed. You can either ZELLE your balance
                                to dfwvga.info@dfwvga.com, or settle your fee at the golf course.
                                <br/>
                            </span>
                        </div>

                    </v-card-text>
                </v-card>

                <v-card-text>
                    <br/><br/>
                    <v-form>
                        <div v-if="tournament!==null && tournament.formatType==='TOURNAMENT'">
                            <v-card-label style="margin-top: 30px;font-weight:bold;color:red;"  v-if="!$AuthSvc.isMember()">
                                You are not a member. Join Today?
                            </v-card-label>
                            <v-container fluid  v-if="!$AuthSvc.isMember()">
                                <v-row align="center">
                                    <v-col class="d-flex" cols="12" sm="16">
                                        <v-select v-model="membershipSelection" @change="onChange()"
                                                  :items="membershipSelections"
                                                  label="Membership Fee"
                                        ></v-select>
                                    </v-col>

                                </v-row>
                            </v-container>
                        </div>

                        <v-card-label style="margin-top: 20px" v-if="!hasProximity()">
                            Do you live EAST or WEST of DFW Airport? <br>
                        </v-card-label>
                        <v-container fluid v-if="!hasProximity()">
                            <v-row align="center">
                                <v-col class="d-flex" cols="12" sm="16">
                                    <v-select v-model="proximity"
                                              :items="proximitySelections"
                                              label="Select EAST or WEST"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-container>

                        <br>
                        <b>NOTE:</b> Only Blue - Tournament tee box are able to receive cup points.<br>
                        <v-card-label style="margin-top: 20px">Select Tee Box:</v-card-label>
                        <v-container fluid>
                            <v-row align="center">
                                <v-col class="d-flex" cols="12" sm="16">
                                    <v-select v-model="playTeebox" @change="onPlayTeeboxChange()"
                                              :items="playTeeboxes"
                                              label="Select Tee Box"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-container>

                        <v-card-label style="margin-top: 30px"  v-if="isBanquet()">Do you have Guest(s)?</v-card-label>
                        <v-container fluid  v-if="isBanquet()">
                            <v-row align="center">
                                <v-col class="d-flex" cols="12" sm="16">
                                    <v-select v-model="guestSelection" @change="onGuestChange()"
                                              :items="numGuestSelections"
                                              label="Select Number Of Guest(s)"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-container>

                        <v-container fluid v-if="isBanquet()">
                            <v-row v-for="idx in banquetGuests.length" :key="idx">
                                <v-col>
                                    Enter Full Name Guest {{idx}}: <v-text-field v-model="banquetGuests[idx-1]"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>

                        <v-card-label style="margin-top: 30px" v-if="!isBanquet() && tournament!==null && tournament.formatType==='TOURNAMENT' && !isBanquet()">
                            Hole In One Buy In - $1K Payout (4 par 3 holes)
                        </v-card-label>
                        <v-container fluid  v-if="tournament!==null && tournament.formatType==='TOURNAMENT' && !isBanquet()">
                            <v-row align="center">
                                <v-col class="d-flex" cols="12" sm="16">
                                    <v-select v-model="holeInOne" @change="onChange()"
                                            :items="holeInOneSelections"
                                            label="Select Hole In One option"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-container>

                        <v-card-label style="margin-top: 30px" v-if="!isBanquet() && tournament!==null && tournament.formatType==='TOURNAMENT' && !isBanquet()">
                            Birdie Hunt? ($10 entry fee)
                        </v-card-label>
                        <v-container fluid  v-if="tournament!==null && tournament.formatType==='TOURNAMENT' && !isBanquet()">
                            <v-row align="center">
                                <v-col class="d-flex" cols="12" sm="16">
                                    <v-select v-model="birdieHunt" @change="onChange()"
                                              :items="birdieHuntSelection"
                                              label="Select birdie hunt option"
                                    ></v-select>
                                </v-col>

                            </v-row>
                        </v-container>

                        <v-card-label style="margin-top: 30px" v-if="!isBanquet()">Special Request</v-card-label>
                        <v-container fluid v-if="!isBanquet()">
                            <v-text-field v-model="specialRequest">Enter request</v-text-field>
                        </v-container>

                        <v-card-label style="margin-top: 30px">Payment Selection</v-card-label>

                        <v-container fluid
                                     v-if="tournament!==null && tournament.formatType==='TOURNAMENT' && totalPlayers < tournament.limitSize && !isBanquet()">
                            <v-row align="center">
                                <v-col class="d-flex" cols="12" sm="16">
                                    <v-select v-model="paymentType" @change="onChange()"
                                              :items="paymentTypeSelections"
                                              label="Payment Type"
                                    ></v-select>
                                </v-col>

                            </v-row>
                        </v-container>

                        <v-container fluid
                                     v-if="tournament!==null && tournament.formatType==='TOURNAMENT' && totalPlayers >= tournament.limitSize && !isBanquet()">
                            <v-row align="center">
                                <v-col class="d-flex" cols="12" sm="16">
                                    <v-select v-model="paymentType" @change="onChange()"
                                              :items="paymentTypeSelections2"
                                              label="Payment Type"
                                    ></v-select>
                                </v-col>

                            </v-row>
                        </v-container>

                        <v-container fluid v-if="isBanquet()">
                            <v-row align="center">
                                <v-col class="d-flex" cols="12" sm="16">
                                    <v-select v-model="paymentType" @change="onChange()"
                                              :items="paymentTypeSelections"
                                              label="Payment Type"
                                    ></v-select>
                                </v-col>

                            </v-row>
                        </v-container>

                        <v-container fluid v-if="tournament!==null && tournament.formatType==='FUN'">
                            <v-row align="center">
                                <v-col class="d-flex" cols="12" sm="16">
                                    <v-select v-model="paymentType" @change="onChange()"
                                              :items="funPaymentTypeSelections"
                                              label="Payment Type"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-container>

                        <span class="label14">Fee: ${{fee}}</span>
                        <div v-if="!isBanquet() && tournament.formatType==='TOURNAMENT'">
                            <br>
                            <span class="label14">Hole In One Fee: ${{hioFee}}</span>
                            <br>
                            <span class="label14">Birdie Hunt: ${{birdieHunt==='Yes'?'10':'0'}}</span>
                            <br v-if="membershipFeeCost">
                            <span class="label14" v-if="membershipFeeCost">Membership Fee: ${{membershipFeeCost}}</span>
                        </div>
                        <br><br>
                        <span class="label16">Total Fee: ${{totalFee}} </span>
                    </v-form>
                </v-card-text>
                <v-card-actions class="actions-card">
                    <v-btn style="background-color:darkgreen;color:white;" @click="formSubmit()">Register</v-btn>
                </v-card-actions>
            </v-card>

        </v-card>

    </div>
</template>

<script>
import moment from 'moment';
import swal from 'sweetalert';

  export default {
    name: "login",
    data: () => ({
      JUNIOR_FEE: 50,
      membershipFeeCost: 0,
      membershipSelection: 'Not at this time',
      memberFee: 0,
      fee: 0,
      lateFee: 0,
      hioFee: 0,
      totalFee: 0,
      totalPlayers: 0,
      paymentType: 'Zelle',
      raffle: 0,
      proximity: 'Select One',
      holeInOne: "Select One",
      guestSelection: "Select One",
      playTeebox: 'Select One',
      birdieHunt: "Select One",
      birdieHuntFee: 0,
      tournament: null,
      userInfo: null,
      scoreCard: null,
      specialRequest: '',
      banquetGuests: [],
      totalGuests: 0,
      membershipSelections: [
        "Select One",
        "Join as Member Now",
        "Not at this time"
      ],
      paymentTypeSelections: [
        "Select One",
        "Zelle",
        "Complimentary"
      ],
      paymentTypeSelections2: [
        "Select One",
        "StandBy"
      ],
      funPaymentTypeSelections: [
        "Select One",
        "Zelle",
        "Settle at course"
      ],
      holeInOneSelections: [
        "Select One",
        "Yes - $5",
        "No - Not Interested"
      ],
      birdieHuntSelection: [
        "Select One",
        "No",
        "Yes"
      ],
      proximitySelections: [
        "Select One",
        "EAST",
        "WEST"
      ],
      playTeeboxes: [
        "Select One",
        "Blue - Tournament",
        "White",
        "Red or Ladies"
      ],
      numGuestSelections: [
        "Select One",
        "0 - No Guest",
        "1 - Guest",
        "2 - Guests",
        "3 - Guests",
        "4 - Guests",
        "5 - Guests",
        "6 - Guests",
        "7 - Guests"
      ]
    }),
    mounted: function () {
        var _this = this;
        _this.userInfo = this.$AuthSvc.getUserInfo();
        this.proximity = this.$AuthSvc.getUserInfo().proximity;
        if (this.proximity===null) {
            this.proximity = '';
        }

        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('id')
        if (id !== null && id !== '') {
            _this.$CommandSvc.get(_this, '/public/tournament-course/' + id, function(data) {
                if (data !== null) {
                    _this.tournament = data.tournament;
                    if (_this.tournament.formatType === 'BANQUET') {
                      window.location.href = '/registration-banquet?id='+_this.tournament.tournamentId;
                    } else {
                        _this.tournament.course = data.course;
                        window.sessionStorage.setItem('selectTournament', JSON.stringify(_this.tournament));
                        _this.loadScoreCard();
                    }
                }
            });
        }
        else {
            _this.$CommandSvc.get(_this, '/public/tournaments/status/REGISTER', function (data) {
                if (data.length === 1) {
                    _this.tournament = data[0].tournament;
                    if (_this.tournament.formatType === 'BANQUET') {
                      window.location.href = '/registration-banquet?id='+_this.tournament.tournamentId;
                    } else {
                        _this.tournament.course = data[0].course;
                        window.sessionStorage.setItem('selectTournament', JSON.stringify(_this.tournament));
                        _this.loadScoreCard();
                    }
                }
            });
        }
    },
    methods: {
      hasProximity() {
        return this.$AuthSvc.getUserInfo().proximity !== null && this.$AuthSvc.getUserInfo().proximity !== '';
      },
      printDateTime(date) {
          return moment(date).format('MMMM Do hh:mm A');
      },
      printDate(date) {
          return moment(date).format('MMM Do');
      },
      isBanquet() {
          if (this.tournament !== null) {
              return (this.tournament.tournamentId === 33);
          }

          return false;
      },
      isEarly(ts) {
        var now = moment();
        return now.isBefore(ts)
      },
      invoice() {
        if (this.$AuthSvc.isFw() && ['FUN_FW', 'FUN_FW_TEAM'].includes(this.tournament.formatType)) {
            console.log("Firewheel crew");
        }
        else {
          window.location.href = '/registration-invoice';
        }
      },
      loadScoreCard() {
          var _this = this;

          this.totalGuests = 0;
          this.JUNIOR_FEE = this.tournament.juniorFee==='' ? 50 : Number(this.tournament.juniorFee);

          if (_this.userInfo !== null && _this.tournament !== null) {
              this.axios.get('/public/scores/players/' + _this.tournament.tournamentId + '/' + _this.userInfo.playerId)
                  .then(function (response) {
                      if (response.data !== null && response.data != "") {
                          _this.scoreCard = response.data;

                          if (_this.isBanquet()) {
                              _this.fee = 0;

                              if (!_this.$AuthSvc.isMember()) {
                                  _this.fee = _this.tournament.guestFee;
                              }

                              _this.totalFee = _this.fee;
                          }

                      }
                      _this.onChange();
                  })
                  .catch(function (error) {
                      console.log('ERROR: ' + error);
                  });

              this.axios.get('/public/scores/players/' + _this.tournament.tournamentId + '/count')
                  .then(function (response) {
                      _this.totalPlayers = response.data;
                      if (_this.totalPlayers >= _this.tournament.limitSize) {
                          _this.paymentType = 'StandBy';
                      }
                  })
                  .catch(function (error) {
                      console.log('ERROR: ' + error);
                  });
          }
      },
      onPlayTeeboxChange() {
      },
      onGuestChange() {
        this.fee = 0;
        if (!this.$AuthSvc.isMember()) {
            this.fee = Number(this.tournament.guestFee);
        }

        this.banquetGuests = [];
        var numGuests = this.guestSelection.substr(0,1);

        if (numGuests > 0 ) {
            if (!this.$AuthSvc.isMember()) {
                this.fee = this.fee + (numGuests * this.tournament.guestFee);
            }
            else {
                this.fee = this.fee + ((numGuests-1) * this.tournament.guestFee);
            }
        }

        this.totalFee = this.fee;

        for(var i=0; i < numGuests; i++) {
            this.banquetGuests.push('');
        }
      },
      onChange() {
        this.lateFee = 0;

        if (this.$AuthSvc.getUserInfo().status === 'NON-MEMBER') {
            if (this.membershipSelection === 'Join as Member Now') {
              this.memberFee = Number(this.tournament.memberFee);

              this.fee = this.memberFee;
              this.totalFee = this.fee;

              var now = moment();
              if (now.isAfter(this.tournament.earlyRegisterDeadline)) {
                this.lateFee = 0;
              }

              if (this.$AuthSvc.isJunior() || this.$AuthSvc.isSenior()) {
                this.membershipFeeCost = 60;
              }
              else {
                this.membershipFeeCost = 120;
              }

              if (this.$AuthSvc.isJunior() ) {
                this.memberFee = this.JUNIOR_FEE;
                this.lateFee = 0
              }
            }
            else {
              this.memberFee = Number(this.tournament.guestFee);
              this.membershipFeeCost = 0;
            }
        }
        else {
          if (this.$AuthSvc.isMember()) {

              this.memberFee = Number(this.tournament.memberFee);

              this.fee = this.memberFee;
              this.totalFee = this.fee;

              var now = moment();
              if (now.isAfter(this.tournament.earlyRegisterDeadline)) {
                if (!this.$AuthSvc.isJunior()) {
                  this.lateFee = 0;
                }
              }

              if (this.$AuthSvc.isJunior() ) {
                this.memberFee = this.JUNIOR_FEE;
                this.lateFee = 0
              }
          }
          else {
            this.memberFee = Number(this.tournament.guestFee);
            this.fee = this.memberFee;
            this.lateFee = 0
          }
        }

        this.memberFee += this.lateFee;
        this.fee = this.memberFee;
        this.totalFee = this.fee;

        if (this.holeInOne === 'Yes - $5') {
          this.hioFee = 5;
        }
        else {
          this.hioFee = 0;
        }

        if (this.birdieHunt === 'Yes') {
            this.birdieHuntFee = 10;
        }
        else {
            this.birdieHuntFee = 0;
        }

        this.totalFee = this.fee + this.membershipFeeCost + this.hioFee + this.birdieHuntFee;
      },
      getFlight(flight) {
        if (flight === "Nicklaus") {
            return "Nicklaus (≤0-7.99)";
        } else if (flight === "Palmer") {
            return "Palmer (8-15.99)";
        } else if (flight === "Hogan") {
            "Hogan (16-30+)";
        } else if (flight === "Women") {
            return "Women";
        } else {
            return "Unknown";
        }
      },
      addFee(addFee) {
        this.fee += addFee;
      },
      validateForm() {
          if (this.tournament.formatType==='FUN') {
            this.holeInOne = 'No - Not Interested';
            this.birdieHunt = 'No';
          }
          if (this.proximity === 'Select One') {
            swal("Need More Info", "Please choose EAST or WEST on where you live.", "info");
            return false;
          } else if (this.playTeebox === 'Select One') {
            swal("Need More Info", "Please choose Tee Box selection.", "info");
            return false;
          } else if (this.holeInOne === 'Select One') {
            swal("Need More Info", "Please choose Hole-In-One selection.", "info");
            return false;
          } else if (this.birdieHunt === 'Select One') {
            swal("Need More Info", "Please choose Birdie Hunt selection.", "info");
            return false;
          }
          return true;
      },
      formSubmit() {
          var _this = this;

          if (!this.validateForm()) {
            return;
          }

          var totalBanquetFee = 0;
          if (_this.isBanquet()) {
            this.specialRequest = '';

            if (!this.$AuthSvc.isMember()) {
                totalBanquetFee += Number(_this.tournament.guestFee);
            }

            for(var i=0; i < this.banquetGuests.length; i++) {
              var fee =  '$' + _this.tournament.guestFee;;
              if (this.$AuthSvc.isMember() && i === 0) {
                fee = 'FREE';
              } else {
                totalBanquetFee += Number(_this.tournament.guestFee);
              }

              this.banquetGuests[i] = "(" + (i+1) + ") " + this.banquetGuests[i] + " - " + fee;
              this.specialRequest =  this.banquetGuests.join(", ");
            }

            this.fee = totalBanquetFee;
            this.totalFee = totalBanquetFee;
          }

          var userInfo = this.$AuthSvc.getUserInfo();
          var scoreCard = {
            playerId: userInfo.playerId,
            tournamentId: this.tournament.tournamentId,
            flight: userInfo.flight,
            isOfficial: false,
            isRegister: true,
            fee: this.fee,
            lateFee: this.lateFee,
            raffle: this.banquetGuests.length + 1,
            memberFee: this.membershipFeeCost,
            holeInOne: this.hioFee,
            birdieHunt: this.birdieHunt,
            owe: this.totalFee,
            paymentType: this.paymentType,
            specialRequest: this.specialRequest,
            member: this.$AuthSvc.isMember()?'Y':'N',
            playTeebox: this.playTeebox
          };

          this.axios.post('/api/tournaments/registration', scoreCard)
          .then(function (response) {
              _this.scoreCard = response.data;

              var scoreCardData = JSON.stringify(response.data);
              window.sessionStorage.setItem('score-card', scoreCardData);

              if (_this.scoreCard.paymentType !== null && _this.scoreCard.paymentType === 'PayPal') {
                window.location.href  = '/registration-invoice';
              }
          })
          .catch(function (error) {
              swal("Error", "Registration failed.", "error");
              console.log('ERROR: ' + error);
          });


          this.axios.put('/api/players/' + _this.userInfo.playerId + '/proximity/' + _this.proximity)
          .then(function (response) {
              var userInfo = _this.$AuthSvc.getUserInfo();
              userInfo.proximity = _this.proximity;
              var userInfoJson = JSON.stringify(userInfo);
              window.sessionStorage.setItem('userInfo', userInfoJson);
          })
          .catch(function (error) {
              swal("Error", "Registration failed.", "error");
              console.log('ERROR: ' + error);
          });
      },
    }
  }
</script>

<style scoped>
  .v-card {
    background-color: #e6f2ea;
  }

  .registration-card {
    padding: 10px;
    margin-bottom: 20px;
  }

  .registration-card * {
    font-size: 14px;
  }

  .v-checkbox, .v-input {
    margin: 0;
    padding: 0;
  }


  .login {
    margin-top: 12px;
    width: 100%;
  }

  .actions-card {
    margin-top: 20px;
  }

  @media (min-width: 768px) {

  }

</style>